import React from "react";
import { ETLCodes } from "../locales";
import { showError, showSuccess } from "nsitools-react";
import { useTl } from "./useTl";
import { ErrorDetails } from "../api";

export interface IUseSaveApi<T> {
  saveApiFn: (data: T) => Promise<any> | any;
  onSaveFn?: () => void;
}

export function useSaveApi<T>(options: IUseSaveApi<T>) {
  const [saving, setSaving] = React.useState(false);
  const { onSaveFn, saveApiFn } = options;
  const { t, tUnsafe } = useTl();
  const saveItem = React.useCallback(
    async (values: T) => {
      try {
        setSaving(true);
        await saveApiFn(values);
        showSuccess(t(ETLCodes.SaveSuccess));
        onSaveFn && onSaveFn();
      } catch (error) {
        const details: ErrorDetails = JSON.parse(error.response);
        if (details?.errorCode) {
          showError(tUnsafe(`BackendError_${details.errorCode}`));
        } else {
          showError(t(ETLCodes.Error));
        }
      }
      setSaving(false);
    },
    [onSaveFn, saveApiFn, t, tUnsafe]
  );

  return {
    saveItem,
    saving,
  };
}
